/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { localDate } from '../../../utils/dateUtils';
import { Table, Badge, Spin, Button, Space, Row, Col, Pagination } from 'antd';
import { filter, get } from 'lodash-es';
import { createUseStyles } from 'react-jss';
import { Link } from 'react-router-dom';
import Search from 'antd/lib/input/Search';
import { useEffect, useRef, useState } from 'react';
import { Popover, PopoverHeader, PopoverBody } from 'reactstrap';
import ChargerDetailCard from '../ChargerDetailCard';
import '../../Reusable/popover.css';
import PageSizer from 'components/Common/PageSizer';
import { useFetchCorporateGroups } from 'utils/queries/corporate';
import GroupDetailCard from '../GroupDetailCard';
import CorporateChargersMap from 'components/map/CorporateChargersMap';

const useStyles = createUseStyles({
  onlineOfflineBadgeIcon: {
    '& .ant-badge-status-dot': {
      height: '11px',
      width: '11px',
    },
  },
});

export default function CorporateChargersList({
  showMap = false,
  data,
  corporateId,
  isLoading = false,
  isError,
}) {
  const classes = useStyles();
  const [currentPage, setCurrentPage] = useState(1);
  const [pageLimit, setPageLimit] = useState(100);
  const [queryString, setQueryString] = useState('');
  const [filteredChargers, setFilteredChargers] = useState([]);
  const [activePopoverId, setActivePopoverId] = useState('');
  const [activeGroupPopoverId, setActiveGroupPopoverId] = useState('');
  const { data: groups } = useFetchCorporateGroups();

  function displayConnectors(connectors) {
    return connectors.length > 0 ? (
      connectors.map((c) => (
        <div>
          {c.TYPE} ({displayVehicleTypes(c.TYPE)})
        </div>
      ))
    ) : (
      <>-</>
    );
  }
  function displayVehicleTypes(connectorsType) {
    if (
      connectorsType === 'CCS1' ||
      connectorsType === 'CCS2' ||
      connectorsType === 'TYPE2'
    )
      return <>Four wheeler</>;
    else return <>Two wheeler</>;
  }
  // return (c.TYPE==='CCS2' || c.TYPE==='Type2') ?<>Four wheeler</>:<>Two wheeler</>
  function getGroupDetails(name) {
    let grps = [];
    if (groups?.data?.length > 0) {
      grps = filter(groups?.data, (g) => g?.NAME === name);
    }
    return grps?.length > 0 ? grps[0] : null;
  }
  const columns = [
    {
      title: 'Id',
      dataIndex: 'ID',
      render: (name, cp) => (
        <>
          <Badge
            status={get(cp, 'isOnline') ? 'processing' : 'error'}
            color={get(cp, 'isOnline') ? '#52c41a' : '#f94d4f'}
            className={classes.onlineOfflineBadgeIcon}
          />
          <Link
            id={`Popover${cp.ID}`}
            to={`/corporate/charger/detail/${get(
              cp,
              'JP_CORPORATE_LOCATION.JP_CORPORATE',
            )}/${get(cp, 'ID')}/${get(cp, 'JP_CORPORATE_CHARGER.ID')}`}
            onMouseEnter={(e) => {
              setActivePopoverId(`Popover${cp.ID}`);
            }}
          >
            {cp.ID}
          </Link>

          {cp.ID && (
            <ChargerDetailCard
              cp={cp}
              cpid={cp.ID}
              activePopoverId={activePopoverId}
              isChargerLoading={false}
              onClickOutside={() => {
                setActivePopoverId('');
              }}
            />
          )}
        </>
      ),
      width: 250,
    },
    {
      title: 'Group',
      dataIndex: 'group',
      render: (name, cp, idx) => (
        <>
          <a
            id={`GroupPopover_${idx}_${get(cp, 'JP_CORPORATE_LOCATION.ID')}`}
            onMouseEnter={() => {
              setActiveGroupPopoverId(
                `GroupPopover_${idx}_${get(cp, 'JP_CORPORATE_LOCATION.ID')}`,
              );
            }}
          >
            {get(cp, 'JP_CORPORATE_LOCATION.NAME')}
          </a>
          {get(cp, 'JP_CORPORATE_LOCATION.NAME') && (
            <GroupDetailCard
              idx={idx}
              detail={getGroupDetails(get(cp, 'JP_CORPORATE_LOCATION.NAME'))}
              groupId={get(cp, 'JP_CORPORATE_LOCATION.ID')}
              activePopoverId={activeGroupPopoverId}
              isChargerLoading={false}
              onClickOutside={() => {
                setActiveGroupPopoverId('');
              }}
            />
          )}
        </>
      ),
      width: 150,
    },
    {
      title: 'Plan',
      dataIndex: 'plan',
      render: (name, cp) => <>{get(cp, 'JP_CORPORATE_PLANS.NAME')}</>,
      width: 150,
    },
    {
      title: 'Name',
      dataIndex: 'name',
      render: (name, cp) => (
        <>
          <Link
            to={`/corporate/charger/detail/${get(
              cp,
              'JP_CORPORATE_LOCATION.JP_CORPORATE',
            )}/${get(cp, 'ID')}/${get(cp, 'JP_CORPORATE_CHARGER.ID')}`}
          >
            {name}
          </Link>
        </>
      ),
      width: 250,
    },
    {
      title: 'Type',
      dataIndex: 'type',
      render: (name, cp) => <>{cp.type}</>,
      width: 70,
    },
    {
      title: 'Connector (Vehicle type)',
      dataIndex: 'type',
      render: (name, cp) => displayConnectors(cp?.CONNECTORS),
      width: 220,
    },

    {
      title: 'Capacity (kW)',
      dataIndex: 'capacity',
      render: (name, cp) => <>{cp.capacity}</>,

      width: 125,
    },
    {
      title: 'Last Heart beat',
      dataIndex: 'createdAt',
      render: (name, cp) => <>{localDate(cp?.LAST_HEARTBEAT)}</>,
      width: 200,
    },
    {
      title: 'Updated on',
      dataIndex: 'createdAt',
      render: (name, cp) => <>{localDate(cp.createdAt)}</>,
      width: 200,
    },
  ];

  function onPageSizeChange(newPageSize) {
    setPageLimit(newPageSize);
  }

  function makeData(data) {
    const formattedSessions = data?.slice(
      (currentPage - 1) * pageLimit,
      currentPage * pageLimit,
    );

    return formattedSessions;
  }

  function getFooter() {
    return (
      <div
        style={{
          float: 'right',
          display: 'flex',
          justifyContent: 'flex-end',
          margin: 0,
        }}
      >
        <div style={{ marginTop: 5 }}>
          Total {data?.length ? data?.length : 0} records
        </div>
        <Pagination
          current={currentPage}
          defaultCurrent={1}
          pageSize={pageLimit}
          total={data?.length}
          onChange={(pageSize) => {
            setCurrentPage(pageSize);
          }}
        />
        <PageSizer
          onChangeHandler={(newPageSize) => {
            onPageSizeChange(newPageSize);
          }}
          selectedPageSize={pageLimit}
        />
      </div>
    );
  }

  return (
    <Spin tip="Loading..." spinning={isLoading}>
      {showMap && data?.length > 0 && <CorporateChargersMap records={data} />}
      {groups?.data?.length > 0 && (
        <Table
          rowKey="id"
          columns={columns}
          dataSource={makeData(data)}
          pagination={false}
          scroll={{ y: '70vh' }}
          footer={() => getFooter()}
        />
      )}
    </Spin>
  );
}
